import { enumValue, getGapStatusRollups } from '~/util/enums';
import { moment } from '~/vendorConfigs/moment';

export function isProtected(hcc: RiskGapType, submission?: null | PatientSubmissionType) {
    if (submission?.dov && !hcc?.submission_answer && hcc?.metadata?.CreatedDate) {
        const currentDate = moment();
        const dateOfVisit = moment(submission.dov);
        const createdDate = moment(hcc.metadata.CreatedDate);

        if (
            dateOfVisit.isBefore(currentDate) &&
            currentDate.diff(dateOfVisit, 'days') <= 30 &&
            dateOfVisit.isBefore(createdDate) &&
            createdDate.diff(dateOfVisit, 'days') <= 30
        ) {
            return true;
        }
    }

    return false;
}

export function attestationSubmitSort(a: RiskGapType, b: RiskGapType) {
    if (!a?.icd?.code && !b?.icd?.code) {
        return a?.code.localeCompare(b?.code);
    }

    if (!a?.icd?.code) return 1;
    if (!b?.icd?.code) return -1;

    return a.icd.code.localeCompare(b.icd.code);
}

export function attestationSort(riskGaps: RiskGapType[], status: number) {
    function sectionReduce(
        acc: { [key: number]: { title: boolean | string; entries: RiskGapType[] } },
        x: RiskGapType
    ) {
        if (
            [
                enumValue(['gap', 'status', 'Addressed']),
                enumValue(['gap', 'status', 'Under Review']),
            ].includes(status)
        ) {
            if (!acc[0])
                acc[0] = {
                    title: false,
                    entries: [],
                };
            acc[0].entries.push(x);
            return acc;
        }
        if (!x?.risk_gap_section?.section) {
            if (!acc[999])
                acc[999] = {
                    title: 'Manually Added Condition(s)',
                    entries: [],
                };
            acc[999].entries.push(x);
            return acc;
        }
        if (!acc[x.risk_gap_section.section])
            acc[x.risk_gap_section.section] = {
                title: x.risk_gap_section.description,
                entries: [],
            };
        acc[x.risk_gap_section.section].entries.push(x);
        return acc;
    }

    function statusFilter(x: RiskGapType) {
        return getGapStatusRollups(enumValue(['gap', 'type', 'Risk Gap']), status).includes(
            x.status
        );
    }

    function mapSiblings(riskGap: RiskGapType) {
        const gaps = [];
        riskGap.siblings?.forEach((sibling) => {
            sibling.id = riskGap.id;
            gaps.push(sibling);
        });
        gaps.push(riskGap);
        return gaps;
    }

    return riskGaps.flatMap(mapSiblings).filter(statusFilter).reduce(sectionReduce, {});
}

export function attestationSectionSort(
    entries: RiskGapType[],
    submission: null | PatientSubmissionType
) {
    function checkProtection(hcc: RiskGapType) {
        return isProtected(hcc, submission);
    }

    function sectionSort(a: RiskGapType, b: RiskGapType) {
        const aProtected = checkProtection(a);
        const bProtected = checkProtection(b);

        if (aProtected && !bProtected) {
            return 1;
        }
        if (bProtected && !aProtected) {
            return -1;
        }

        if (!a?.icd?.code && !b?.icd?.code) {
            return a?.code.localeCompare(b?.code);
        }

        if (!a?.icd?.code) return 1;
        if (!b?.icd?.code) return -1;

        return a.icd.code.localeCompare(b.icd.code);
    }

    return entries.sort(sectionSort);
}

export function sortFocActions(fga1: FocActionType, fga2: FocActionType) {
    let sortVal = fga1.sequence - fga2.sequence;
    if (sortVal === 0) {
        if (fga1.foc_action_details[0]?.name < fga2.foc_action_details[0]?.name) {
            sortVal = -1;
        }
        if (fga1.foc_action_details[0]?.name > fga2.foc_action_details[0]?.name) {
            sortVal = 1;
        }
    }
    return sortVal;
}
